import React, {
	Component
} from 'react';
import { observer } from 'mobx-react';
import {
    WeaDialog,
    WeaTab,
    WeaButtonIcon,
    WeaLocaleProvider
} from 'ecCom';
import {
	WeaTableNew
} from 'comsMobx';
import findIndex from 'lodash/findIndex';
const {
	WeaTable
} = WeaTableNew;

@observer
export default class TemplateEdit extends Component {
	constructor(props) {
        super(props);
    }

    doEdit = (id, record) => {
        this.props.store.editTemplate(record);
    }

    doSaveAs = (id) => {
        this.props.store.saveAs(id);
    }

    doDelete = (id) => {
        this.props.store.deleteTemplate({id});
    }

    onOperatesClick = (record, index, operate) => {
		const func = operate.href ? operate.href.split(':')[1].split('(')[0] : '';
		const id = record.id ? record.id : '';
		this[func] && this[func](id, record);
	}

	renderCol = (cols) => {
		let idx = findIndex(cols, item => item.dataIndex === 'name');
		idx != -1 && (cols[idx].render = (text, record) => {
			return <a onClick={() => this.doEdit(record.id, record)}>{WeaLocaleProvider.formatMultiLang(record.name)}</a>
		})
	}

	render() {
		const {
            store
        } = this.props;
        const {
            editDialogParams,
            multiDelete,
            templateStore,
            editTemplate,
            deleteTemplate
        } = store;
        const tableProps = {
			scroll: {
				y: 380
			}
		}

		return (
            <WeaDialog  {...editDialogParams} buttons={[]} moreBtn={{datas: []}} layout={document.getElementsByClassName('wea-hrm-address')[0]}>
                <WeaTab
                    datas={[]}
                    keyParam="viewcondition"  //主键
                    buttons={[
                    <WeaButtonIcon buttonType='add' type="primary" onClick={() => editTemplate()}/>,
                    <WeaButtonIcon buttonType='del' type="primary" onClick={() => deleteTemplate({})} disabled={multiDelete}/>,
                    ]}
                />
                <WeaTable comsWeaTableStore={templateStore} 
                    {...tableProps} 
                    needScroll={true}
                    onOperatesClick={(record, index, operate) => this.onOperatesClick(record, index, operate)}
                    getColumns={cols => this.renderCol(cols)}
                />
            </WeaDialog>
        )
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/resourceExportTemplate/TemplateEdit.js